module.exports = __webpack_public_path__ + "static/img/vr7.bcd5b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr7.png
// module id = rUE7
// module chunks = 1